function showMobileHeader(context, value) {
  context.commit('toggleMobileHeader', value);
}

function showDesktopHeader(context, value) {
  context.commit('toggleDesktopHeader', value);
}

function setGlobalModal(context, value) {
  context.commit('setGlobalModal', value);
}

function setCookiesModal(context, value) {
  context.commit('setCookiesModal', value);
}

function openPropositionModal(
  context,
  { propositionId, propositionId2, type, trigger = null }
) {
  context.commit('setPropositionViewModalId', {
    propositionId,
    propositionId2,
    type,
    trigger
  });
}

function closePropositionModal(context) {
  context.commit('pageModalActivePage', 'proposition');

  context.commit('setPropositionViewModalId', {
    propositionId: null,
    propositionId2: null,
    type: null,
    trigger: null
  });
}

// change name to tab
function setPageModalActivePage(context, value) {
  context.commit('pageModalActivePage', value);
}

function setPageModalZIndex(context, value) {
  context.commit('pageModalZIndex', value);
}

function toggleDisableScroll(context, val) {
  context.commit('toggleDisableScroll', val);
}

function setTabAnsweredClicks(context, value) {
  context.commit('setTabAnsweredClicks', value);
}

function showEndMatchConfirm(context, { params, onConfirm, onCancel }) {
  context.commit('setEndMatchConfirm', {
    show: true,
    params,
    onConfirm,
    onCancel
  });
}

function cancelEndMatchConfirm(context) {
  const { onCancel } = context.state.endMatchConfirm;
  context.commit('setEndMatchConfirm', {
    show: false,
    params: null,
    onConfirm: null,
    onCancel: null
  });
  if (onCancel) onCancel();
}

async function confirmEndMatch(context) {
  const { onConfirm } = context.state.endMatchConfirm;
  context.commit('setEndMatchConfirm', {
    show: false,
    params: null,
    onConfirm: null,
    onCancel: null
  });
  if (onConfirm) await onConfirm();
}

// The modal renders data fetched by its trigger, so it never opens empty.
function showCompleteListingModal(context, { summary, recentVisitors }) {
  context.commit('setCompleteListingModalData', { summary, recentVisitors });
  context.commit('setGlobalModal', 'CompleteListingModal');
}

export default {
  showMobileHeader,
  showDesktopHeader,
  setGlobalModal,
  setCookiesModal,
  openPropositionModal,
  closePropositionModal,
  setPageModalActivePage,
  setPageModalZIndex,
  toggleDisableScroll,
  setTabAnsweredClicks,
  showEndMatchConfirm,
  cancelEndMatchConfirm,
  confirmEndMatch,
  showCompleteListingModal
};
